import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import industry from './views/industry.vue'
import aboutUs from './views/about.vue'
import jobs from './views/jobs.vue'
import contactUs from './views/contact.vue'
// import banking from './views/banking.vue'

import enterprise from '@/components/service/enterprise'
import businessProcess from '@/components/service/businessProcess'
import digital from '@/components/service/digital'
import enterpriseApplication from '@/components/service/enterpriseApplication'
import crm from '@/components/service/crm'

import blockchains from '@/components/service/blockchains'
import businessApplication from '@/components/service/businessApplication'
import dataAnalytics from '@/components/service/dataAnalytics'
import artificialIntelligence from '@/components/service/artificialIntelligence'

import softwareDevelopment from '@/components/service/softwareDevelopment'
import enterpriseMobility from '@/components/service/enterpriseMobility'
import cloud from '@/components/service/cloud'
import networkSecurity from '@/components/service/networkSecurity'
import globalization from '@/components/service/globalization'
import bigData from '@/components/service/bigData'
import internetThings from '@/components/service/internetThings'

import applicationOutsourcing from '@/components/service/applicationOutsourcing'
import businessProcessOutsourcing from '@/components/service/businessProcessOutsourcing'
import customerService from '@/components/service/customerService'
import humanResource from '@/components/service/humanResource'
Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'home', component: Home },
    { path: '/industry', name: 'industry', component: industry },
    { path: '/about', name: 'aboutUs', component: aboutUs },
    { path: '/jobs', name: 'jobs', component: jobs },
    { path: '/contactUs', name: 'contactUs', component: contactUs },
    // { path: '/banking', name: 'banking', component: banking },
    // 服務
    { path: '/enterprise', name:'enterprise', component: enterprise },
    { path: '/businessProcess', name:'businessProcess', component: businessProcess },
    { path: '/digital', name: 'digital', component: digital },
    { path: '/enterpriseApplication', name: 'enterpriseApplication', component: enterpriseApplication },
    { path: '/crm', name: 'crm', component: crm },
    { path: '/blockchains', name: 'blockchains', component: blockchains },
    { path: '/businessApplication', name: 'businessApplication', component: businessApplication },
    { path: '/dataAnalytics', name: 'dataAnalytics', component: dataAnalytics },
    { path: '/artificialIntelligence', name: 'artificialIntelligence', component: artificialIntelligence },
    { path: '/softwareDevelopment', name: 'softwareDevelopment', component: softwareDevelopment },
    { path: '/enterpriseMobility', name: 'enterpriseMobility', component: enterpriseMobility },
    { path: '/cloud', name: 'cloud', component: cloud },
    { path: '/networkSecurity', name: 'networkSecurity', component: networkSecurity },
    { path: '/globalization', name: 'globalization', component: globalization },
    { path: '/bigData', name: 'bigData', component: bigData },
    { path: '/internetThings', name: 'internetThings', component: internetThings },
    { path: '/applicationOutsourcing', name: 'applicationOutsourcing', component: applicationOutsourcing },
    { path: '/businessProcessOutsourcing', name: 'businessProcessOutsourcing', component: businessProcessOutsourcing },
    { path: '/customerService', name: 'customerService', component: customerService },
    { path: '/humanResource', name: 'humanResource', component: humanResource }
  ]
});
